/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import { useState, useEffect, useContext } from 'react';
import { GrLocation } from 'react-icons/gr';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { Link, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import { showTost } from '../../showTost';
import Payment from '../Payment/Payment';
import { uid } from 'uid';
import { useTranslation } from 'react-i18next';
import { FaTag } from "react-icons/fa";

const OrderSummery = () => {

  const { t } = useTranslation();
  const { BaseUrl, paymentRes, transactionId, setPaymentRes } = useContext(MyContext);

  const [isWallet, setIsWallet] = useState(false);
  const [myWallet, setMyWallet] = useState(0);
  const [walletUsed, setWalletUsed] = useState(0);
  const [copyWallet, setCopyWallet] = useState(0);
  const [couponList, setCouponList] = useState([]);
  const [showCouponBox, setShowCouponBox] = useState(false);
  const [selectCoupon, setSelectCoupon] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [couponCodeId, setCouponCodeId] = useState("");
  const [couponCodeValue, setCouponCodeValue] = useState("");
  const [discountType, setDiscountType] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [total, setTotal] = useState(0);
  const [showPaymentBox, setShowPaymentBox] = useState(false);
  const [refCode, setRefCode] = useState("");
  const [refApplied, setRefApplied] = useState(false);

  const LocalData = sessionStorage.getItem("EventData");
  const Data = JSON.parse(LocalData);

  const Navigate = useNavigate();

  const Localcurrency = localStorage.getItem("currency");
  const Currency = Localcurrency ? Localcurrency : "₹";

  useEffect(() => {
    window.scrollTo(0, 0);

    const Wallet = localStorage.getItem("Wallet");
    setMyWallet(Math.round(Number(Wallet)));

    HandleGetCouponList();

    const baseTotal = Data?.Totalprice + Data?.Tax;
    setCopyWallet(baseTotal);
    setTotal(baseTotal);

  }, []);

  useEffect(() => {
    calculateTotal();
  }, [selectCoupon, isWallet, copyWallet]);

  const calculateTotal = () => {
    let baseTotal = Number(copyWallet);
    let discount = 0;

    if (selectCoupon) {
      const couponValue = Number(selectCoupon.amt);

      if (selectCoupon.discount_type === "percentage") {
        // 10% of subtotal (without tax)
        discount = (Number(Data?.Totalprice) * couponValue) / 100;
      }

      if (selectCoupon.discount_type === "amount") {
        discount = couponValue;
      }
    }

    discount = Math.min(discount, baseTotal); // safety

    let afterCoupon = baseTotal - discount;

    let walletAmount = 0;
    if (isWallet && myWallet > 0) {
      walletAmount = Math.min(afterCoupon, myWallet);
    }

    setWalletUsed(walletAmount);
    setTotal(Math.round(afterCoupon - walletAmount));
  };

  const HandleGetCouponList = () => {
    const Userid = localStorage.getItem("Userid");
    if (Userid) {
      axios.post(`${BaseUrl}user_api/u_couponlist.php`, {
        uid: Userid,
        sponsore_id: Data?.Sponsoreid ? Data?.Sponsoreid : "0"
      })
        .then((res) => {
          setCouponList(res?.data?.couponlist);
        })
        .catch((error) => {
          console.error("u_couponlist", error);
        });
    }
  };

  const HandleSelectCoupon = (item) => {

    if (myWallet < item.min_amt) {
      return;
    }

    const Userid = localStorage.getItem("Userid");
    if (Userid) {
      axios.post(`${BaseUrl}user_api/u_check_coupon.php`, {
        uid: Userid,
        cid: item.id
      })
        .then((res) => {
          if (res.data.ResponseCode === "200") {
            showTost(res.data.ResponseMsg, "success");
            setSelectCoupon({ code: item.coupon_code, amt: item.coupon_val, discount_type: item?.discount_type });
            setDiscountType(item?.discount_type)
            setShowCouponBox(false);
          }
        })
        .catch((error) => {
          console.error("u_check_coupon", error);
        });
    }
  };

  const handleCouponCodeChange = (e) => {
    const value = e.target.value.toUpperCase(); // UX improvement

    setCouponCode(value);

    const coupon = couponList?.find(
      item => item?.coupon_code?.toUpperCase() === value
    );

    setCouponCodeId(coupon ? coupon.id : null);
    setCouponCodeValue(coupon ? coupon?.coupon_val : null);
    setDiscountType(coupon ? coupon?.discount_type : null)
  };

  const handleApplyCouponCode = async () => {
    const Userid = localStorage.getItem("Userid");

    if (!couponCode.trim()) {
      showTost("Enter coupon code", "error");
      return;
    }

    try {
      setIsApplyingCoupon(true);

      const res = await axios.post(`${BaseUrl}user_api/u_check_coupon.php`, {
        uid: Userid,
        cid: couponCodeId,
      });

      if (res.data.ResponseCode === "200") {
        showTost(res.data.ResponseMsg, "success");

        setSelectCoupon({
          code: couponCode.toUpperCase(),
          amt: couponCodeValue,               // RAW value
          discount_type: discountType
        });

        setShowCouponBox(false);
        setCouponCode("");
        setTotal(`${discountType === "percentage" ? (Data.Totalprice - (Data.Totalprice * couponCodeValue) / 100)?.toFixed(0) : (Data.Totalprice - couponCodeValue)}`);
      } else {
        showTost(res.data.ResponseMsg || "Invalid coupon", "error");
      }

    } catch (err) {
      // console.error(err);
      showTost("Coupon apply failed", "error");
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  useEffect(() => {
    const PaymentRes = sessionStorage.getItem("Paymentstatus");

    if (!PaymentRes) return;

    if (PaymentRes === "PaymentDone") {
      setPaymentRes("PaymentDone");
    } else {
      setPaymentRes("PaymentFaild");
    }
  }, [setPaymentRes]);

  useEffect(() => {
    if (!paymentRes) return;

    if (paymentRes === "PaymentDone") {
      HandleBookingEvent(1);
    } else {
      sessionStorage.setItem("Amount", "0");
      sessionStorage.setItem("Paymentstatus", "");
      setPaymentRes("");
      showTost(t("Payment Faild !!"), "error");
    }

  }, [paymentRes]);

  const HandleBookingEvent = (id) => {

    const Userid = localStorage.getItem("Userid");
    const TotalAmt = sessionStorage.getItem("Amount");
    const Paymentid = sessionStorage.getItem("Paymentid");

    const total_amt = total || TotalAmt;
    const wall_amt = isWallet ? walletUsed : "0";

    const BookingData = {
      uid: Userid,
      eid: Data?.Eventid,
      typeid: Data?.Typeid,
      type: Data?.Type,
      price: Data?.Singleprice,
      total_ticket: Data?.con,
      subtotal: Data?.Totalprice,
      tax: Data?.Tax,
      cou_amt: selectCoupon
        ? (
          selectCoupon.discount_type === "percentage"
            ? (Data.Totalprice * selectCoupon.amt) / 100
            : selectCoupon.amt
        )
        : "0",
      total_amt,
      wall_amt,
      p_method_id: id === 0 ? "3" : Paymentid,
      transaction_id: id === 0 ? "0" : (transactionId || uid(20)),
      plimit: Data?.plimit,
      sponsore_id: Data?.Sponsoreid ? Data?.Sponsoreid : "0",
    };

    axios.post(`${BaseUrl}user_api/book_ticket.php`, BookingData)
      .then((res) => {
        showTost(res.data.ResponseMsg, "success");
        setShowPaymentBox(false);
        sessionStorage.clear();
        setPaymentRes("");
        Navigate("/booking");
      })
      .catch((error) => {
        console.error("book_ticket", error);
      });
  };

  const HandleConfirm = () => {
    if (total === 0) {
      HandleBookingEvent(0);
    } else {
      setShowPaymentBox(true);
      sessionStorage.setItem("pages", "booking");
    }

  };

  const handleApplyReferral = async () => {
    const loginId = localStorage.getItem("Userid");

    if (!refCode.trim()) {
      showTost("Enter referral code", "error");
      return;
    }

    try {
      const res = await axios.post(
        "https://yblapis.ganpatigroupbharat.com/api/auth/apply_ref_code",
        {
          loginId: Number(loginId),
          refrenceCode: refCode.trim()
        }
      );

      if (res.data?.success) {
        showTost("Referral code applied successfully", "success");
        setRefApplied(true);
        setRefCode("");
      } else {
        showTost(res.data?.message || "Invalid referral code", "error");
      }

    } catch (error) {
      showTost("Referral apply failed", "error");
    }
  };

  // const filteredDaata = couponList?.filter(item => item?.is_display === "0" || item?.is_display === 0);

  return (
    <div className="width_container">

      <div className="flex items-center gap-[10px] justify-between mt-[10px] max-_430_:hidden">
        <div className="flex items-center gap-[10px] border-[2px] rounded-[50px] text-white px-[10px] py-[5px] cursor-pointer hover:bg-[#23262F] group">
          <HiChevronLeft className=" group-hover:text-white" />
          <Link to="/" className="font-bold text-[14px] group-hover:text-white">{t("Go home")}</Link>
        </div>
        <div className="flex items-center gap-[15px]">
          <Link to="/event-details" className="font-bold text-[14px] text-white">{t("Event Details")}</Link>
          <HiChevronRight />
          <h1 className="font-bold text-[14px] text-white">{t("Confirm and pay")}</h1>
        </div>
      </div>

      <div className="order_summery">

        <div className="w-[35%] max-_580_:w-[100%] max-_770_:w-[70%] max-_1025_:w-[60%] max-_1205_:w-[50%] max-_1450_:w-[45%] max-_1550_:w-[40%]">

          <div className="order_box mb-[10px]">

            <div className="flex max-_430_:flex-wrap items-center gap-[20px]">
              <img src={Data?.Eventimg} className="w-[100px] h-[100px] max-_430_:w-[100%] max-_430_:h-[200px] rounded-[20px] object-cover" alt="" />
              <div className="">
                <h1 className="font-bold">{Data?.Eventtitle}</h1>
                <span className="text-[15px] text-white">{Data?.Eventdate}</span>
                <div className="flex items-center gap-[10px]">
                  <GrLocation className="text-[25px]" />
                  <p className="text-[14px]">{Data?.Eventaddress}</p>
                </div>
              </div>
            </div>

            <div className="bg-[#383838] p-[15px] rounded-[10px] mt-[15px]">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-[10px]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 24 24" fill="currentColor" stroke="none" className="text-[#d2a347] tabler-icon tabler-icon-rosette-discount-filled "><path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path></svg>
                  <h1 className="text-[#d2a347] text-[18px] max-_430_:text-[16px]">{t("Apply Coupon")}</h1>
                </div>
                {selectCoupon ? (
                  <span className="text-green-600 font-bold">Applied ✓</span>
                ) : (
                  <span className="text-[#d2a347] text-[16px]" style={{ cursor: "pointer" }} onClick={() => selectCoupon ? " " : setShowCouponBox(true)}>View all Coupon</span>
                )}
              </div>

              <div className="border-[2px] rounded-[50px] px-[15px] py-[10px] mt-[10px]">
                <div className="flex items-center justify-between">
                  {!selectCoupon ? (
                    <>
                      <input
                        type="text"
                        value={couponCode}
                        onChange={handleCouponCodeChange}
                        placeholder="Enter Coupon Code"
                        className="outline-none bg-transparent text-[15px] w-full"
                      />

                      <button
                        onClick={handleApplyCouponCode}
                        disabled={isApplyingCoupon || !couponCode}
                        className="text-[#d2a347] font-bold text-[14px]"
                      >
                        {isApplyingCoupon ? "Applying..." : "Apply"}
                      </button>
                    </>
                  ) : (
                    <>
                      <h1 className="text-green-600 font-bold text-[15px]">
                        {selectCoupon.code}
                      </h1>

                      <button
                        onClick={() => {
                          setSelectCoupon(null);
                          setCouponCode("");
                          setCouponCodeId(null);
                        }}
                        className="text-[15px] text-red-500"
                      >
                        {t("Remove")}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="bg-[#515151] p-[15px] rounded-[10px] mt-[15px]">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-[10px]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 24 24" fill="currentColor" stroke="none" className="text-[#d2a347] tabler-icon tabler-icon-rosette-discount-filled "><path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path></svg>
                  <h1 className="text-[#d2a347] text-[18px] max-_430_:text-[16px]">{t("Apply Referral Code")}</h1>
                </div>
                {!refApplied ? (
                  <button onClick={handleApplyReferral} className="text-[#d2a347] text-[16px]">{t("Apply")}</button>
                ) : (
                  <span className="text-green-600 font-bold">Applied ✓</span>
                )}
              </div>

              <div className="border-[2px] rounded-[50px] px-[15px] py-[10px] mt-[10px]">
                <div className="flex items-center justify-between">
                  <input
                    type="text"
                    value={refCode}
                    disabled={refApplied}
                    onChange={(e) => setRefCode(e.target.value.toUpperCase())}
                    placeholder="Enter referral code"
                    className="w-full rounded-[50px] outline-none bg-transparent mr-[10px]"
                  />
                </div>
              </div>
            </div>

            {/* <div className="bg-[#f1f2f4] p-[15px] rounded-[10px] mt-[15px]">
              <h1>{t("Pay from wallet")}</h1>
              <div className="border-[2px] px-[15px] py-[15px] rounded-[10px] mt-[10px]">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-[15px]">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22 6H6C3.79086 6 2 7.79086 2 10V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6Z" stroke="#28303F" strokeWidth="1.5" strokeLinejoin="round" />
                      <path d="M22 6C22 3.79086 20.2091 2 18 2H12C9.79086 2 8 3.79086 8 6V6H22V6Z" stroke="#28303F" strokeWidth="1.5" strokeLinejoin="round" />
                      <path d="M2 12L2 16L6 16C7.10457 16 8 15.1046 8 14V14C8 12.8954 7.10457 12 6 12L2 12Z" stroke="#28303F" strokeWidth="1.5" strokeLinejoin="round" />
                    </svg>
                    <div className="leading-[18px]">
                      <h1 className="max-_430_:text-[15px]">{t("Your Balance")} {Currency}{isWallet ? myWallet - walletUsed : myWallet}</h1>
                      <span className="text-[14px]">{t("Available for Payment")}</span>
                    </div>
                  </div>
                  <div onClick={() => setIsWallet(!isWallet)} className="switch_box">
                    <input className="switch_input" type="checkbox" />
                    <span className="switch_inner">
                      <span className={`switch_box ₹{isWallet && "switch_box_on"}`}></span>
                    </span>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="mt-[20px]">
              <h1 className="text-[23px] font-bold mb-[10px]">{t("Price details")}</h1>

              <div className="flex items-center justify-between py-[8px] px-[10px]">
                <h1 className="text-white text-[15px]">{t("Price")}</h1>
                <span className="text-[15px]">₹{Data?.Totalprice}</span>
              </div>

              <div className="flex items-center justify-between py-[8px] px-[10px]">
                <h1 className="text-white text-[15px]">{t("Fee")}</h1>
                <span className="text-[15px]">+₹{Data?.Tax}</span>
              </div>

              {walletUsed > 0 && (
                <div className="flex items-center justify-between py-[8px] px-[10px]">
                  <h1 className="text-white text-[15px]">{t("Wallet")}</h1>
                  <span className="text-[15px]">-{Currency}{walletUsed}</span>
                </div>
              )}

              {/* {selectCoupon && (
                <div className="flex items-center justify-between py-[8px] px-[10px]">
                  <h1 className="text-gray-600 text-[15px]">{t("Coupon")}</h1>
                  <span className="text-[15px]">-{Currency}{`${Math.round(selectCoupon.amt)}`}</span>
                </div>
              )} */}

              {selectCoupon && (
                <div className="flex items-center justify-between py-[8px] px-[10px]">
                  <h1 className="text-gray-600 text-[15px]">{t("Coupon")}</h1>
                  <span className="text-[15px]">
                    -{Currency}{
                      Math.round(
                        selectCoupon.discount_type === "percentage"
                          ? (Data.Totalprice * selectCoupon.amt) / 100
                          : selectCoupon.amt
                      )
                    }
                  </span>
                </div>
              )}


              <div className="flex items-center justify-between py-[8px] bg-[#f1f2f4] px-[10px] rounded-[10px]">
                <h1 className="text-gray-600 text-[15px]">{t("Total Payment")}</h1>
                <span className="text-[15px] text-gray-600">{Currency}{total}</span>
              </div>


            </div>

          </div>

          <button onClick={HandleConfirm} style={{ borderRadius: "20px" }} className="button">{t("Confirm")}</button>
        </div>

      </div>

      {showCouponBox && <div onClick={() => setShowCouponBox(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="coupon_box">
          {couponList?.length > 0 ? (
            <>
              <h1 className="font-bold text-[20px]">{t("Available coupons")}</h1>

              <div className="max-h-[500px] scroll-container">
                {couponList?.map((item, index) => {

                  return <div key={index} className="coupon_list">
                    <div className="flex items-center gap-[10px]">
                      <div className="bg-white p-[10px] rounded-[10px]">
                        <img src={BaseUrl + item.c_img} className="w-[40px]" alt="" />
                      </div>
                      <div className="">
                        <h1 className="text-[15px]">{item.coupon_title}</h1>
                        <p className="text-[14px] text-gray-500">{item.coupon_subtitle}</p>
                        <span className="text-[15px]">{t("Expires")} {item.expire_date}</span>
                      </div>
                    </div>
                    <button onClick={() => HandleSelectCoupon(item)} className={`whitespace-nowrap ₹{myWallet > item.min_amt ? "text-[#d2a347]" : "text-gray-600 cursor-default"} text-[15px]`}>{t("Apply")}</button>
                  </div>
                })
                }
              </div>
            </>
          ) : (
            <div className="py-[12px] px-[20px] login-box flex items-center gap-3 bg-yellow-50 border border-yellow-300 rounded-lg">
              <FaTag className="text-yellow-600 text-[26px]" />

              <div>
                <h1 className="text-[18px] font-semibold text-yellow-800">
                  {t("No Coupons Available")}
                </h1>
                <p className="text-[14px] text-yellow-700">
                  {t("There are currently no coupon codes available. Please check back later for new offers.")}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>}

      {showPaymentBox && <div onClick={() => setShowPaymentBox(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="coupon_box">
          <Payment Amount={total} setShowPaymentBox={setShowPaymentBox} />
        </div>
      </div>}

    </div>
  )
}

export default OrderSummery;
/* jshint ignore:end */
